import { userInformation } from "../../components/CheckoutComponent/data";
import { selectedProduct, paymentInfo } from "../../store/nanostore";
import { environment } from "../../env";
import * as Yup from "yup";

export const paymentUserSchema = Yup.object().shape({
  email: Yup.string().required("Email is required"),
  name: Yup.string().required("Name is required"),
  phone: Yup.string()
    .min(8, "Provide a valid phone number")
    .required("Phone number is required"),
});

export const handleSubmitUser = async (value: any, handleSubmit: any) => {
  try {
    const payload = {
      name: value.name,
      email: value.email,
      phone: String(value.phone),
      paymentLinkId: selectedProduct.get()?.[0]?.paymentLinkId,
      products: selectedProduct
        .get()
        ?.map(({ id, quantity }: any) => ({ id, quantity: quantity || 1 })),
    };

    console.table(payload);
    const {
      data: { createOrder },
    } = await handleSubmit({
      variables: {
        ...environment.paymentService,
        payload,
      },
    });
    paymentInfo.set({ ...createOrder, payload });
  } catch (e) {
    console.error(e);
    throw e;
  }
};
export const userSection = {
  initialValue: userInformation.reduce(
    (acc, cr) => ({
      [cr.name]: cr.type,
    }),
    {}
  ),
  schema: paymentUserSchema,

  title: "User Information",
  handleSubmit: handleSubmitUser,
};
